import { CacheProvider } from "@emotion/react";
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import ReactDOM from "react-dom/client";
import { useState } from "react";
import type { FC } from "react";
import { colors, spacing } from "../design-tokens";
import { applyThemeVariables, readWidgetAttributes } from "@/utils/widget-runtime";

const PlaygroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["3xl"]}px;
  background-color: ${colors.surface};
  min-height: 50px;
`;

const PlaygroundComponent: FC = () => {
  const [value, setValue] = useState("");

  return (
    <PlaygroundContainer>
    </PlaygroundContainer>
  );
};

class PlaygroundWebComponent extends HTMLElement {
  private root: ReactDOM.Root | null = null;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    applyThemeVariables(this, readWidgetAttributes(this));

    const cache = createCache({
      key: "shadow-emotion",
      container: this.shadowRoot as unknown as Element,
    });

    this.root = ReactDOM.createRoot(this.shadowRoot as ShadowRoot);
    this.root.render(
      <CacheProvider value={cache}>
        <PlaygroundComponent />
      </CacheProvider>,
    );
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}

export default PlaygroundWebComponent;
